// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3n3Pr","footer":"Form_footer__14nNv"};